const normalizeNamePunctuation = (value: string) => value
  .replace(/[\u2018\u2019\u201B\u2032]/g, "'")
  .replace(/[\u2010-\u2015\u2212]/g, "-");

const isRomanNumeral = (value: string) => value.length <= 4 && /^[ivxlcdm]+$/i.test(value);

const normalizeNameSegment = (value: string) => {
  if (value.length === 0) {
    return "";
  }
  if (isRomanNumeral(value)) {
    return value.toUpperCase();
  }

  let firstLetterSeen = false;
  return Array.from(value).map((character) => {
    if (/\p{L}/u.test(character)) {
      if (!firstLetterSeen) {
        firstLetterSeen = true;
        return character.toLocaleUpperCase();
      }
      return character.toLocaleLowerCase();
    }
    return character;
  }).join("");
};

const normalizeNameWord = (value: string) => {
  let segment = "";
  let result = "";

  for (const character of Array.from(value)) {
    if (character === "'" || character === "-") {
      result += normalizeNameSegment(segment) + character;
      segment = "";
      continue;
    }
    segment += character;
  }

  return result + normalizeNameSegment(segment);
};

export const normalizePersonName = (value: string) => {
  const normalized = normalizeNamePunctuation(value)
    .replace(/\s+/g, " ")
    .trim();

  if (!normalized) {
    return "";
  }

  return normalized
    .split(" ")
    .map(normalizeNameWord)
    .join(" ");
};
